export default __webpack_public_path__ + "static/media/InProgress.6ec8062e.png";